module.exports = __webpack_public_path__ + "img/lmzlist.23587478.png";